import AllFieldsApi from '@/services/api/admin/AllFieldsApi'

export default {
	/**
	 * Get all non-admin fields 
	 */
	async all ({ commit }, ) {
		try {
			const allFields = await AllFieldsApi.all()
			commit('setAllFields', allFields)
		} catch (err) {
			throw err
		}	
	}
}